//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { PoolAbi } from '@shared/Abis'
import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'
import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'
import { UserConnection } from '@shared/DeploymentConfigTypes'

export const acceptEarlyRedeemRequestTx =
  (props: { poolAddr: EthAddr; lenderAddr: EthAddr }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.WITHDRAW_REQUEST
    try {
      const { webSocket } = getState().chainState
      const { chainConfigurationName } = getState().chainState.chainConfiguration
      const { roleEnum, signer } = getState().chainState.userConnection as UserConnection
      if (roleEnum && chainConfigurationName) {
        assertRole(roleEnum, RoleEnum.BORROWER)
        const { poolAddr, lenderAddr } = props

        logOT.debug('acceptEarlyRedeemRequestSaga', poolAddr)

        await acceptEarlyRedeemRequest(webSocket, signer as Signer, poolAddr, lenderAddr, chainConfigurationName)
        dispatch(poolActions.acceptEarlyRedeemRequestSuccess(props))
      }
    } catch (e: any) {
      dispatch(poolActions.acceptEarlyRedeemRequestFail(props))
      await dispatchError(dispatch, e, activity, 1016)
    }
  }

export const acceptEarlyRedeemRequest = async (
  webSocket: WebSocket | undefined,
  borrowerSigner: Signer,
  poolAddr: EthAddr,
  lenderAddr: EthAddr,
  chainConfigurationName: string
): Promise<void> => {
  logOT.debug('acceptEarlyRedeemRequest')
  logOT.debug('acceptEarlyRedeemRequest', poolAddr, lenderAddr, !!borrowerSigner)
  const uuid = txUUID()
  webSocket?.send(wsServerActionPoolTXRequest(ActivityEnum.WITHDRAW_REQUEST, poolAddr, uuid, chainConfigurationName))

  const poolContract = new Contract(poolAddr, PoolAbi, borrowerSigner)

  const tx = await poolContract.acceptEarlyRedeemRequest(lenderAddr)

  webSocket?.send(
    wsServerActionPoolTX(ActivityEnum.WITHDRAW_REQUEST, poolAddr, uuid, tx.hash as TxHash, chainConfigurationName)
  )
  await tx.wait(1)

  logOT.debug('acceptEarlyRedeemRequest tx', tx)
}
